import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '../../../API/axiosNeatex';
import type { ProcessesModels } from './MrpProcessesModels';

export const AddProcesses = createAsyncThunk(
  'MrpProcesses/AddProcesses',
  async (item: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await ntxAPI.post('MRP/AddProcesses', item);
      await dispatch(getProcessesList());
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateProcesses = createAsyncThunk(
  'MrpProcesses/updateProcesses',
  async (item: any, { rejectWithValue, dispatch }) => {
    try {
      const { data } = await ntxAPI.post('MRP/UpdateProcesses', item);
      await dispatch(getProcessesList());

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getProcessesList = createAsyncThunk(
  'MrpProcesses/getProcessesList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('MRP/GetProcessesList');
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getProcessesById = createAsyncThunk(
  'MrpProcesses/getProcessesById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('MRP/GetProcessesById', { params: { id: id } });
      if (data.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  ProcessesList: ProcessesModels[];
  ProcessesById: ProcessesModels;
  loading: boolean;
  loadingById: boolean;
  error: any | null;
} = {
  ProcessesList: [],
  ProcessesById: {} as ProcessesModels,
  loading: false,
  loadingById: false,
  error: null,
};

const ProcesseSlice = createSlice({
  name: 'MrpProcesses',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder

      .addCase(getProcessesList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getProcessesList.fulfilled, (state, action: PayloadAction<ProcessesModels[]>) => {
        state.loading = false;
        state.ProcessesList = action.payload;
      })
      .addCase(getProcessesList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
      .addCase(getProcessesById.pending, (state, action) => {
        state.loadingById = true;
      })
      .addCase(getProcessesById.fulfilled, (state, action: PayloadAction<ProcessesModels>) => {
        state.loadingById = false;
        state.ProcessesById = action.payload;
      })
      .addCase(getProcessesById.rejected, (state, action: PayloadAction<any>) => {
        state.loadingById = false;
        state.error = action.payload;
      });
  },
});

export default ProcesseSlice.reducer;
